import useSelector from "src/utils/useSelector";
import { getTranscriptRequest, handlePusherMessage } from "src/components/Chat/redux/actions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logError } from "src/utils/logger";
import { Dispatch } from "redux";
import getConversationsEmbedConfig from "src/components/Chat/utils/getConversationsEmbedConfig";
import Pusher from "pusher-js";

let pusher: Pusher;

export default function useChatConnection() {
    const dispatch = useDispatch();

    const isAppOpen = useSelector((state) => state.onlineShopper.isAppOpen);
    const token = useSelector((state) => state.messages?.conversations_config?.token);
    const channel = useSelector((state) => state.messages?.conversations_config?.channel);
    const enabled = useSelector((state) => state.account.settings?.electric?.message_center_enabled);
    const missingConversationsConfig = window.DIConversationsConfig === undefined;

    useEffect(() => {
        if (isAppOpen && enabled && channel && token && !missingConversationsConfig) {
            connectToConversation(dispatch, token, channel);
        }

        return disconnectFromConversation;
    }, [isAppOpen, enabled, token, channel, missingConversationsConfig]);
}

function connectToConversation(dispatch: Dispatch, token: string, channel: string): void {
    disconnectFromConversation();

    const config = getConversationsEmbedConfig();

    pusher = new Pusher(config.pusherKey, {
        auth: {
            headers: {
                "X-Visitor-Token": token,
            },
        },
        authEndpoint: `${config.endpoint}/pusher/auth/visitor`,
        cluster: "mt1",
    });

    new Promise((resolve) => {
        pusher.connection.bind("connected", resolve);
    })
        .then(() => {
            const channelSubscription = pusher.subscribe(channel);

            channelSubscription.bind_global((eventName: string, data: any) =>
                dispatch(handlePusherMessage(eventName, data))
            );

            dispatch(getTranscriptRequest(token, channel));
        })
        .catch((e) => {
            logError(e);
        });
}

function disconnectFromConversation(): void {
    if (typeof pusher !== "undefined") {
        pusher.disconnect();
    }
}
